import React, { useContext } from 'react';
import { Channel } from 'talkplus-sdk/dist/model/types';
import ChatListItem from '@components/chat/common/chatListItem';
import { ListLoadingMotion } from '@components/chat/common/loadingList';
import { ChatContext, ChatContextType } from '@components/chat/ChatContext';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface AllChatListProps {
  handleChannelClick: (channel: Channel) => void;
  className?: string;
}

const AllChatList = ({ handleChannelClick, className }: AllChatListProps) => {
  const { channelsData } = useContext<ChatContextType>(ChatContext);

  const listEls = channelsData?.channels
    ?.sort((a, b) => b.memberCount - a.memberCount)
    .slice(0, 20)
    .map((channel, index) => {
      const handleClick = () => {
        handleChannelClick(channel);
      };
      return <ChatListItem key={index} channel={channel} onClick={handleClick} />;
    });

  return (
    <div className={cx('listArea', className)}>
      <span className={cx('title')}>인기 채팅</span>

      {listEls ? <ul className={cx('listWrap')}>{listEls}</ul> : <ListLoadingMotion />}
    </div>
  );
};

export default AllChatList;
